import { RequestTypes } from './types';
import { modes, CustomEvents } from '@powerplay/common';
export class ExitGameManager {
    active = false;
    typesRequiredToExit = [];
    exitRequestTypesDone = 0;
    init(tutorialID) {
        this.setRequiredRequestsForExit(tutorialID);
    }
    setRequiredRequestsForExit(tutorialID) {
        if (!modes.isTutorial())
            this.typesRequiredToExit.push(RequestTypes.saveResults);
        if (tutorialID)
            this.typesRequiredToExit.push(RequestTypes.tutorial);
        this.typesRequiredToExit.push(RequestTypes.log);
    }
    activateExit(type) {
        if (this.typesRequiredToExit.includes(type))
            this.exitRequestTypesDone++;
        if (this.exitRequestTypesDone === this.typesRequiredToExit.length) {
            this.active = true;
            window.dispatchEvent(new CustomEvent(CustomEvents.allRequestDoneOnEnd));
        }
    }
    reset() {
        this.active = false;
        this.exitRequestTypesDone = 0;
    }
}
//# sourceMappingURL=ExitGameManager.js.map